var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGriyasaLogoOnly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1034 0.383282C17.7818 0.390282 17.4606 0.486042 17.1815 0.675252L1.62274 11.2214C1.08197 11.5879 0.852513 12.2047 0.978853 12.7867C0.936653 12.9317 0.913254 13.0845 0.913254 13.2435V41.8624C0.913254 42.1524 0.989553 42.4235 1.12151 42.6587C1.23638 42.9137 1.413 43.1419 1.64706 43.3155C2.35847 43.8433 3.31986 43.6613 3.803 42.9073L9.72563 33.6645L33.2534 33.6376C33.3377 33.6375 33.4208 33.6315 33.5025 33.6189L33.5206 33.6195C34.4072 33.6514 35.1054 32.9047 35.0864 31.9452L34.7122 13.059C34.7112 12.9944 34.7062 12.9302 34.6988 12.8672C34.8913 12.2388 34.6702 11.541 34.0922 11.1371L19.2171 0.743981C18.8975 0.498721 18.5002 0.374142 18.1034 0.383282ZM18.1845 4.15979L31.4576 13.4342L31.7919 30.3241L9.21087 30.3499C9.17507 30.3499 9.13977 30.3509 9.10442 30.3539C8.54037 30.2642 7.95722 30.5106 7.61459 31.0453L4.16467 36.4295V13.664L18.1845 4.15979ZM21.5776 17.9832C20.6769 17.9832 19.9518 18.7083 19.9518 19.609V24.8484C19.9518 25.7491 20.6769 26.4742 21.5776 26.4742H26.7209C27.6215 26.4742 28.3466 25.7491 28.3466 24.8484V19.609C28.3466 18.7083 27.6215 17.9832 26.7209 17.9832H21.5776Z",
    fill: "#178480"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGriyasaLogoOnly);
export default __webpack_public_path__ + "static/media/griyasa-logo-only.75192328a31b9d0ee9154d20ce38c234.svg";
export { ForwardRef as ReactComponent };